/**
 * Calcula los totales de un documento programado basándose en las reglas de negocio.
 *
 * Reglas:
 * 1. UF:
 *    - El total de cada ítem es igual a su cantidad.
 *    - El total general es la suma de las cantidades.
 * 2. CLP:
 *    - El subtotal de cada ítem es (cantidad * precio_unitario).
 *    - Si el tipo de DTE es "33" (Factura Electrónica), se aplica un 19% de IVA al total general.
 *    - En otros tipos de DTE (ej. "34" Exenta), no se aplica IVA.
 *
 * @param {Object} doc - El objeto del documento programado.
 * @returns {Object} - Un objeto con { itemTotals: Number[], totalNeto: Number, totalIVA: Number, totalGeneral: Number }
 */
export const calculateProgramadoTotals = doc => {
  const details = doc?.details || []
  const currency = doc?.currency
  const dteTypeCode = String(doc?.dte_type_data?.code || doc?.dte_type || '')

  let totalNeto = 0
  const itemTotals = details.map(item => {
    let total = 0
    if (currency === 'UF') {
      total = Number(item.quantity) || 0
    } else {
      total = (Number(item.quantity) || 0) * (Number(item.unit_price) || 0)
    }
    totalNeto += total
    return total
  })

  let totalGeneral = totalNeto
  let totalIVA = 0

  if (currency === 'CLP' && dteTypeCode === '33') {
    totalIVA = totalNeto * 0.19
    totalGeneral = totalNeto + totalIVA
  }

  return {
    itemTotals,
    totalNeto,
    totalIVA,
    totalGeneral
  }
}
